module.exports = __webpack_public_path__ + "img/ZOE-rezultati2.49cd096f.webp";